// @givmo/compliance — Givmo’s filing desk's words on the web (CCM-R1-DESK-WEB; REVIEW-35's
// frames desk-01 to desk-28).
//
// ══ WHERE EVERY LINE COMES FROM ════════════════════════════════════════════════════════════════
//
// APPROVED by Jonathan on 2026-10-13 ("approve recs" at 21:43 PDT; D-CCM-83; the plan folder's
// `scratchpad/2026-10-13-2143-desk-web-rulings-log.md`, on
// `scratchpad/2026-10-13-desk-web/REVIEW-35-desk-web.html`): N1–N16 as drafted, each named below
// by its number, and the twelve recommendations (Q1–Q12) the screens follow.
//
// APPROVED by Jonathan on 2026-10-12 ("approve recs" at 21:39 PDT; D-CCM-67; the plan folder's
// `scratchpad/2026-10-12-2139-desk-words-rulings-log.md`): the desk's status lines W1–W8 (W3's
// needs, W3a–W3c, are served with the assignment as `need.words`), R5, and frames 21 and 21b's
// first sentence as changed. R1–R4, the desk's authorization statement and its "Authorize" are
// served by the backend and shown as served.
//
// REUSED, approved before: frame 21a's row and frames 21 and 21b's other lines (D-CCM-21, slice
// 1b); "Open the form" (slice 1b), "Revoke" and "Your authorization works until {date}."
// (D-CCM-27, slice 3); what came back after a send (D-CCM-68).

// ── Frame 21a: "Who files it" (D-CCM-21) ───────────────────────────────────────────────────────

export const WHO_FILES_IT = 'Who files it';
export const WE_HANDLE_IT = 'We’ll handle it';
export const WE_HANDLE_IT_LINE = 'Your people, or your own AI, file it.';
export const GIVMO_HANDLES_IT = 'Givmo handles it';
export const GIVMO_HANDLES_IT_LINE =
  'Givmo’s filing desk, run by AI, prepares and sends it once you approve it.';

// ── Frames 21 and 21b: Givmo’s AI turned off (D-CCM-21, with D-CCM-67's first sentence) ─────────

/** D-CCM-67: frames 21 and 21b's first sentence, and the hand-over dialog's (Q2). */
export const RUN_BY_AI =
  'Givmo’s filing desk is run by AI. It prepares a filing and sends it once you approve it.';
export const AI_OFF_TITLE = 'Turn on AI to have Givmo handle this';
/** Frames 21 and 21b's second sentence; under the desk's status too while Givmo has it (Q10). */
export const AI_OFF_LINE =
  'Your organization has “Use AI on your organization’s data” turned off, so Givmo can’t prepare or file this for you until it’s on.';
export const GO_TO_SETTINGS = 'Go to settings';
export const ONLY_OWNERS_TURN_ON = 'Only a Compliance Owner or a Global Admin can turn this on.';
export const GOT_IT = 'Got it';

// ── The desk's status (D-CCM-67) ───────────────────────────────────────────────────────────────

export const W1 =
  'Givmo has this filing. Givmo’s AI prepares it and sends it once your organization approves it.';
export const W2 = 'Givmo is preparing this filing.';
/** W3, with its need as served (`need.words`: W3a–W3c). */
export const w3 = (need: string) => `Givmo needs something from you to continue: ${need}.`;
/**
 * W3c, the need for the organization's authorization, as the backend words it (`NEED_AUTHORIZATION`).
 * The page says it where the read serves no need: a desk send its destination never got (desk-15),
 * which the organization's new authorization sends again while the assignment stays dispatched.
 */
export const W3C_NEED = 'your authorization to send exactly this package';
export const W4 = 'Your organization approved it. Givmo sends it next.';
export const w5 = (date: string) => `Givmo sent it on ${date}.`;
export const W6 = 'The agency’s confirmation is recorded.';
export const w7 = (reason: string) => `Givmo handed this filing back to you: ${reason}.`;
export const W8 =
  'You took this filing back. You can send it yourself with the instructions below.';
export const R5 =
  'Your organization’s agreement for Givmo to file was turned off, so Givmo stopped working on this filing.';
/** D-CCM-67: the button under the desk's authorization statement (the statement itself is served). */
export const AUTHORIZE = 'Authorize';

// ── NEW, approved as drafted (D-CCM-83) ────────────────────────────────────────────────────────

export const N1 = 'Have Givmo handle this filing?';
export const N2 = 'Hand it to Givmo';
export const N3 = 'This ends your organization’s own authorization to send it.';
export const n4 = (name: string, date: string) => `Handed to Givmo by ${name} on ${date}.`;
export const N5 = 'Let Givmo continue';
export const N6 = 'Take this filing back from Givmo?';
export const N7 =
  'Givmo stops working on this filing, and any authorization for Givmo to send it ends.';
export const N8 = 'Take it back';
export const N9 =
  'Givmo can’t send it under the authorization in force. Revoke it, then authorize again.';
export const n10 = (address: string, date: string, time: string) =>
  `Sent by email to ${address} on ${date} at ${time}, by Givmo’s filing desk.`;
export const N11 = 'Sent by Givmo’s filing desk.';
/** N12: in place of a person's name, wherever a row the desk made names who made it (Q7). */
export const N12 = 'Givmo’s filing desk';
export const N13 = 'Review and authorize';
export const n14 = (date: string) => `Your organization agreed to Givmo filing for it on ${date}.`;
export const TURN_OFF = 'Turn off';
export const N15_TITLE = 'Turn off Givmo filing for your organization?';
export const N15_BODY =
  'Givmo stops working on every filing it has for your organization. What it already sent stays sent.';
export const n16 = (date: string) =>
  `Your organization’s agreement for Givmo to file was turned off on ${date}.`;
